<template>
  <div>
    <b-col v-if="isLoading">
      <LoadingSpinner :loading="isLoading" :text="loadingSpinnerText" />
    </b-col>

    <b-col
      v-show="!isLoading"
      class="bg-white pd-main-pdf section dir_rtl text-left"
    >
      <Information :item="profile" />
      <Contact :item="contactItem" />
      <WifeInfo :items="wife" />
      <AddressInfo :items="address" />
      <JobInfo :items="jobs" />
      <EducationInfo :items="educations" />
      <Cultural :items="socials" />
      <Complete :item="complete" />
      <License :items="licenses" />
      <Skills :items="skill" />
      <FreeCourses :items="free_courses" />
      <Articles :items="articles" />
      <FamilyInfo :items="family_relations" />
      <PersonYearsOfService :items="personYearsOfService" />
    </b-col>
    <b-col v-show="!isLoading" class="bg-white py-2 text-center" cols="12">
      <b-form
        @submit="onSubmit"
        class="flex lg:flex-row flex-col gap-2 items-center justify-between w-full"
      >
        <Captcha
          :value="form.captcha"
          id="captcha"
          name="captcha"
          :minLength="captchaLength"
          :maxLength="captchaLength"
          :vuelidateObj="$v.form.captcha"
          @input="input"
          @getKey="updateCaptchaKey"
          @setShowCaptcha="setShowCaptcha"
          @focus="resetValidation"
          @blur="checkValidation"
        />
        <Button
          contentClass="justify-content-center"
          variant="primary"
          :text="$lang.get_pdf_export"
          :disabled="!form.captcha"
          :loading="isSubmitLoading"
          class="w-full"
          @click="onSubmit"
        />
      </b-form>
    </b-col>
  </div>
</template>

<script>
import { Captcha, Button } from "@/components/re-design/forms";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import Information from "./person/Information.vue";
import Contact from "./person/Contact.vue";
import WifeInfo from "./person/WifeInfo.vue";
import AddressInfo from "./person/AddressInfo.vue";
import JobInfo from "./person/JobInfo.vue";
import EducationInfo from "./person/EducationInfo.vue";
import Cultural from "./person/Cultural.vue";
import Complete from "./person/Complete.vue";
import License from "./person/License.vue";
import Skills from "./person/Skills.vue";
import FreeCourses from "./person/FreeCourses.vue";
import Articles from "./person/Articles.vue";
import FamilyInfo from "./person/FamilyInfo.vue";
import PersonYearsOfService from "./person/PersonYearsOfService.vue";
import { includes } from "ramda";
import inputMixin from "@/mixin/inputMixin.vue";
import { getPersonProfilePreviewPdf } from "@/services";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  inject: ["personExportPdfRepository"],
  mixins: [inputMixin],
  components: {
    Captcha,
    Button,
    LoadingSpinner,
    Information,
    Contact,
    WifeInfo,
    AddressInfo,
    JobInfo,
    EducationInfo,
    Cultural,
    Complete,
    License,
    Skills,
    FreeCourses,
    Articles,
    FamilyInfo,
    PersonYearsOfService,
  },
  props: {
    personCode: {
      type: [String, Number],
      default: null,
    },
    exceptProfileKeys: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      loadingSpinnerText: "درحال دریافت اطلاعات...",
      profile: {},
      wife: [],
      address: [],
      articles: [],
      educations: [],
      free_courses: [],
      jobs: [],
      contactItem: {},
      socials: [],
      licenses: [],
      skill: [],
      family_relations: [],
      personYearsOfService: [],
      complete: {},
      code: this.$route.params.code,
      isSubmitLoading: false,
      form: {
        captcha: null,
        captchaKey: null,
      },
    };
  },
  validations() {
    return {
      form: {
        captcha: {
          required: true,
          minLength: minLength(this.captchaLength),
          maxLength: maxLength(this.captchaLength),
        },
      },
    };
  },
  methods: {
    async fetchData() {
      try {
        this.isLoading = true;
        const code = this.personCode || this.code;
        const response = await this.personExportPdfRepository.list(code);
        const {
          profile,
          wife,
          address,
          articles,
          educations,
          free_courses,
          socials,
          licenses,
          skill,
          family_relations,
          person_years_of_service,
          jobs,
          contact,
        } = response.data.data;

        this.profile = this.generateItems(profile, this.exceptProfileKeys);
        this.wife = wife;
        this.address = address;
        this.articles = articles;
        this.educations = educations;
        this.free_courses = free_courses;
        this.jobs = jobs;
        this.socials = socials;
        this.contactItem = contact;
        this.licenses = licenses;
        this.skill = skill;
        this.family_relations = family_relations;
        this.personYearsOfService = person_years_of_service;
        this.complete = {
          biography: profile.biography,
          favorites: profile.favorites,
          final_introduction: profile.final_introduction,
          conviction_history: profile.conviction_history,
        };
        this.isLoading = false;
      } catch (error) {
        this.$generateError(error);
      }
    },
    generateItems(items, exceptKeys) {
      const data = {};
      for (const [key, value] of Object.entries(items)) {
        if (!includes(key, exceptKeys)) {
          data[key] = value;
        }
      }
      return data;
    },
    async onSubmit() {
      try {
        this.isSubmitLoading = true;
        await getPersonProfilePreviewPdf(
          this.personCode,
          this.form.captcha,
          this.form.captchaKey
        );
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isSubmitLoading = false;
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style lang="scss">
.profile-img-pdf {
  position: absolute;
  top: 33%;
  left: 0;
}

.pd-main-pdf {
  padding: 22px 38px;
}

.text-sub {
  font-size: 12px;
  color: #747474;
}

.f-s-b-12 {
  font-size: 12px;
  color: #282c52;
}

.f-s-b-14 {
  font-size: 14px;
  color: #282c52;
}

.quote {
  margin-right: 15px;
  border-right: 1px solid #000000 !important;
  padding: 0 5px;
}
</style>
